import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getFormNodeVisibilityLogicRules } from 'common/entities/formLogicRule/selectors';

import { SuiButton, SuiContainer, SuiModal, SuiModalHeader, SuiModalContent, SuiModalFooter } from '@splashthat/sui';

import FormLogicEditor from './FormLogicEditor';

import { openEditFormNodeLogic, onRequestClose, cancelEditFormNodeLogic, saveEditFormNodeLogic } from '../../actions';
import { addNodeLogicEffect, removeFormLogicEffect, updateFormLogicEffect } from '../../epics/formLogicEffects';

import { getFormId, getEditLogicFormNode, getOperandFormNodesForNode } from '../../selectors';

const DONE = 'Done';
const CANCEL = 'Cancel';
const HEADER = 'Edit Logic and Rules';
const BASE_CLASS_NAME = 'FormLogicModal';

class FormLogicModal extends Component {
    static propTypes = {
        open: PropTypes.bool.isRequired,
        formNode: PropTypes.object,
        formNodeVisibilityLogicRules: PropTypes.array.isRequired,
        operandNodes: PropTypes.array.isRequired,
        cancelEditFormNodeLogic: PropTypes.func.isRequired,
        saveEditFormNodeLogic: PropTypes.func.isRequired,
        updateFormLogicEffect: PropTypes.func.isRequired,
        addNodeLogicEffect: PropTypes.func.isRequired,
        removeFormLogicEffect: PropTypes.func.isRequired,
    };

    static defaultProps = {
        formNode: null,
    };

    renderModalInner() {
        return (
            <SuiContainer variation="border standard-shadow flex-vertical" className="SuiModalContainer">
                <SuiModalHeader onRequestClose={this.props.cancelEditFormNodeLogic}>
                    <h2 className={`${BASE_CLASS_NAME}__headline`}>{HEADER}</h2>
                </SuiModalHeader>

                <SuiModalContent>
                    <FormLogicEditor
                        formNode={this.props.formNode}
                        formNodeVisibilityLogicRules={this.props.formNodeVisibilityLogicRules}
                        operandNodes={this.props.operandNodes}
                        cancelEditFormNodeLogic={this.props.cancelEditFormNodeLogic}
                        saveEditFormNodeLogic={this.props.saveEditFormNodeLogic}
                        addNodeLogicEffect={this.props.addNodeLogicEffect}
                        removeFormLogicEffect={this.props.removeFormLogicEffect}
                        updateFormLogicEffect={this.props.updateFormLogicEffect}
                    />
                </SuiModalContent>

                <SuiModalFooter>
                    <SuiContainer variation="flex-group">
                        <SuiButton variation="secondary" label={CANCEL} onClick={this.props.cancelEditFormNodeLogic} />
                    </SuiContainer>
                    <SuiContainer variation="flex-group">
                        <SuiButton label={DONE} onClick={this.props.saveEditFormNodeLogic} />
                    </SuiContainer>
                </SuiModalFooter>
            </SuiContainer>
        );
    }

    render() {
        return (
            <SuiModal size={SuiModal.MEDIUM} open={this.props.open} useClickOutside closeOnClickOutside={false}>
                {this.props.formNode && this.renderModalInner()}
            </SuiModal>
        );
    }
}

const mapStateToProps = (state) => {
    const formId = getFormId(state);
    const editLogicFormNode = getEditLogicFormNode(state);

    const operandNodes = editLogicFormNode ? getOperandFormNodesForNode(state, formId, editLogicFormNode.id) : [];

    const formNodeVisibilityLogicRules = editLogicFormNode
        ? getFormNodeVisibilityLogicRules(state, formId, editLogicFormNode.id)
        : [];

    return {
        open: !!editLogicFormNode,
        formNode: editLogicFormNode,
        operandNodes,
        formNodeVisibilityLogicRules,
    };
};

const mapDispatchToProps = {
    openEditFormNodeLogic,
    onRequestClose,
    cancelEditFormNodeLogic,
    saveEditFormNodeLogic,
    updateFormLogicEffect,
    addNodeLogicEffect,
    removeFormLogicEffect,
};

export default connect(mapStateToProps, mapDispatchToProps)(FormLogicModal);
